<template>
  <validation-provider
    #default="{ errors }"
    :name="defaultName"
    mode="passive"
    :rules="rules"
  >
    <b-form-group :description="description" :label="label" :label-for="id">
      <cleave
        :name="name"
        v-bind="$attrs"
        v-on="$listeners"
        :id="id"
        class="form-control"
        :raw="true"
        :options="{
          numeral: true,
          numeralIntegerScale: 12,
          numeralThousandsGroupStyle: 'thousand',
        }"
        :class="errors.length > 0 ? 'is-invalid' : ''"
      />

      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import Cleave from "vue-cleave-component";
import { ValidationProvider } from "vee-validate";
import { BFormGroup, BFormInput } from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
export default {
  components: {
    ValidationProvider,
    BFormInput,
    BFormGroup,
    Cleave,
  },
  props: {
    id: {
      type: String,
      default: () => "input",
    },
    name: {
      type: String,
    },
    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
    description: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    };
  },
  computed: {
    defaultName() {
      return this.name || this.label;
    },
  },
};
</script>
